class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.variantButtons = this.querySelectorAll('.color-btn');
    this.variantTitle = this.querySelector('.variant-title');
    this.buyNowPrice = this.querySelector('.price__regular');
    this.buyNowButton = this.querySelector('.buy-now');
    this.variantImages = this.querySelectorAll('img');
    this.variantId = this.querySelector('[name="id"]');
    this.selectedColor = 'warm mint';

    this.getStartedButton = this.querySelector('.get-started');

    this.variantButtons && this.variantButtons.forEach(button => button.addEventListener('click', this.onVariantChange.bind(this)))
    this.getStartedButton && this.getStartedButton.addEventListener('click', this.onGetStartedButtonClick.bind(this));
  }

  onVariantChange(event) {
    let selectedMediaId = event.currentTarget.dataset.mediaId;
    let selectedMedia = this.querySelector(`img[data-media-id="${selectedMediaId}"]`);
    this.selectedColor = event.currentTarget.dataset.variantColor;

    if (this.variantId) {
      this.variantId.value = event.currentTarget.dataset.variant;
    }

    if (this.variantTitle) {
      this.variantTitle.innerHTML = event.currentTarget.dataset.variantTitle;
    }

    if (this.buyNowPrice) {
      const selectedPrice = event.currentTarget.dataset.variantPrice;
      const priceTotal = selectedPrice.split('.');
      if (priceTotal.length == 2) {
        this.buyNowPrice.innerHTML = `
        <span class="price-item price-item--regular">
          ${priceTotal[0]}.
          <sup class="cents">${priceTotal[1]}</sup>
        </span>
        `;  
      }
    }

    if (this.buyNowButton) {
      this.buyNowButton.setAttribute('href', `/cart/${event.currentTarget.dataset.variant}:1`);
    }

    this.variantButtons.forEach(button => button.classList.remove('checked'));
    event.currentTarget.classList.add('checked');

    this.variantImages.forEach(image => image.classList.remove('is-active'));
    selectedMedia.classList.add('is-active');
  }

  async onGetStartedButtonClick(event) {
    event.preventDefault();

    window.location.href = `/pages/get-started?product_color=${this.selectedColor}`;
  }
}

customElements.define('product-card', ProductCard);
